import { Switch, Typography } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import './switch-box.css'
import { twMerge } from 'tailwind-merge'

export type SwitchBoxProps = {
  children?: ReactNode
}

const SwitchBoxGroup = ({ children }: SwitchBoxProps) => {
  return (
    <div className='ui-switch-box group rounded-[12px] border-1 transition-all'>{children}</div>
  )
}

type SwitchBoxItemProps = {
  checked?: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  label: ReactNode
  secondaryText?: ReactNode
  children?: ReactNode
  loading?: boolean
  className?: string
}

const SwitchBoxItem = ({
  checked,
  loading,
  onChange,
  label,
  secondaryText,
  disabled,
  children,
  className,
}: SwitchBoxItemProps) => {
  const isDisabled = disabled || loading
  return (
    <div
      className={twMerge(
        'border-colorSplit border-b-1 p-4 last:border-b-0',
        isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
      onClick={() => !isDisabled && onChange(!checked)}
    >
      <div className='flex flex-col gap-1'>
        <div className='flex items-center gap-3'>
          <span onClick={e => e.stopPropagation()}>
            <Switch
              checked={checked}
              loading={loading}
              onChange={checked => onChange(checked)}
              disabled={disabled}
              size='default'
            />
          </span>
          <Typography.Text strong>{label}</Typography.Text>
        </div>
        {(secondaryText || children) && (
          <div className='flex flex-col gap-1 ps-12'>
            {secondaryText && <Typography.Text type='secondary'>{secondaryText}</Typography.Text>}
            {children && <div onClick={e => e.stopPropagation()}>{children}</div>}
          </div>
        )}
      </div>
    </div>
  )
}

export const SwitchBox = ({ checked = false, ...props }: SwitchBoxItemProps) => {
  return (
    <SwitchBoxGroup>
      <SwitchBoxItem {...props} checked={checked} />
    </SwitchBoxGroup>
  )
}

SwitchBox.Group = SwitchBoxGroup
SwitchBox.Item = SwitchBoxItem
